import React from "react";

// Style
import "./FieldRadio.scss";

// Classnames
import clsx from "clsx";

// Type
type TUnitArray = {
  id?: number,
  label?: string,
  children?: React.ReactNode,
  value?: string | number,
}

interface IFieldRadio {
  id?: string,
  errors?: any,
  name?: string,
  label?: string,
  register?: any,
  subLabel?: string,
  msgError?: string,
  isError?: boolean,
  className?: string,
  disabled?: boolean,
  isColumn?: boolean,
  options?: TUnitArray[],
  placeholder?: string,
  children?: React.ReactNode,
  value?: string | number,
  classNameLabel?: string,
  simpleRadioBtn?: boolean,
  currentValue?: string;
  classNameWrapper?: string,
  classNameBorderWrapper?: string;
  selectedValue?: string | number,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
}

export const FieldGroup: React.FC<IFieldRadio> = (props) => {
  const {
    id,
    name,
    label,
    options,
    isError,
    msgError,
    register,
    isColumn,
    disabled,
    onChange,
    className,
    classNameLabel,
    simpleRadioBtn,
    classNameWrapper,
    classNameBorderWrapper,
  } = props;

  const cnMainWrapper = clsx(
    "field-radio flex full-width",
    classNameWrapper ? classNameWrapper : "",
    isColumn ? "field-radio__column flex-direction-column" : "",
    simpleRadioBtn ? label ? "field-radio__pl" : "" : "full-width field-radio__pl"
  );

  const renderElement = (item: TUnitArray) => {
    const cnText = clsx(
      "flex flex-ai-center field-radio__wrapper",
      className ? className : ""
    );
    const cnLabel = clsx(
      "relative",
      classNameLabel ? classNameLabel : ""
    );
    const cnBorderWrapper = clsx(
      "flex flex-jc-between",
      classNameBorderWrapper ? classNameBorderWrapper : "",
      isColumn ? "flex-ai-start flex-direction-column" : "flex-ai-center"
    );

    const uniqId = crypto.randomUUID();

    return (<React.Fragment key={item.value}>
      <div className={cnBorderWrapper}>
        <p className={cnText}>
          <input
            {...register}

            name={name}
            id={uniqId}
            type="radio"
            value={item.value}
            disabled={disabled}
            className="field-radio__input"
            onChange={onChange ? onChange : {}}
          />
          <label
            htmlFor={uniqId}
            className={cnLabel}
          >
            {item.label || ""}
          </label>
        </p>
        {item.children}
      </div>
    </React.Fragment>);
  };

  return (<div className={cnMainWrapper} id={id}>
    {options?.map(
      (item) => renderElement(item)
    )}

    {isError && <div className="field-radio__hint-radio">
      {msgError}
    </div>}
  </div>);
};

export default FieldGroup;
